import { Button, Col, Row, Space, Table } from 'antd';
import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import CustomPagination from 'components/table/pagination';
import DashboardContext from 'Context';
import SendingMessage from 'components/forms/workerActions/SendingMessage';

export default function WorkerMessages({ id, code, isCustomer = false }) {
  const { urldashboard, authentication } = useContext(DashboardContext);
  // table data
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });

  useEffect(() => {
    getWorkerSchedule({
      page: pagination?.page,
      pageSize: pagination?.pageSize,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getWorkerSchedule = async ({ page, pageSize }) => {
    setLoading(true);
    try {
      let url = isCustomer
        ? '/smsQuery/getCustomerMessages'
        : '/smsQuery/getWorkerMessages';
      const res = await Axios.post(
        urldashboard + url,
        JSON.stringify({
          page,
          userId: code
            ? code
            : isCustomer
              ? sessionStorage.getItem('customerid')
              : sessionStorage.getItem('workerId'),
          pageSize,
          search: '',
        }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        },
      );
      const data = await res.data;
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getWorkerSchedule({
      page: newPage,
      pageSize: newPageSize,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'ارسال کننده',
      dataIndex: 'senderName',
      key: 'senderName',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'متن پیام',
      dataIndex: 'notification',
      key: 'notification',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'زمان ارسال',
      dataIndex: 'persianCreateDate',
      key: 'persianCreateDate',
      responsive: ['xl', 'lg'],
      render: (value, record) => (
        <span>{value ? `${value}${record?.createTime}` : '-'}</span>
      ),
    },
    {
      title: 'دیده شده',
      dataIndex: 'isSeen',
      key: 'isSeen',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => (
        <span>
          {value ? (
            <i
              className='mdi mdi-check'
              style={{ color: 'green', fontSize: '1.5rem' }}
            ></i>
          ) : (
            <i
              className='mdi mdi-close'
              style={{ color: 'red', fontSize: '1.5rem' }}
            ></i>
          )}
        </span>
      ),
    },
  ];

  return (
    <>
      <Row
        gutter={20}
        style={{
          marginTop: 25,
        }}
      >
        <Col span={24} style={{ marginBottom: 20 }}>
          <Space
            wrap
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              width: '100%',
            }}
          >
            <Button
              block
              onClick={() => setCreateModal(true)}
              style={{ height: '3rem' }}
              type='primary'
              className='btn btn-primary border border-secondary rounded-0'
            >
              افزودن
              <i className='mdi mdi-plus mr-2'></i>
            </Button>
          </Space>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Table
            size='small'
            rowClassName={() => 'center'}
            columns={columns}
            bordered={true}
            dataSource={data}
            loading={loading}
            pagination={false}
            locale={{
              emptyText: 'موردی یافت نشد',
            }}
          />

          {!loading && (
            <CustomPagination
              totalRecord={totalRecord}
              pagination={pagination}
              handlePagination={handlePagination}
            />
          )}

          {createModal && (
            <SendingMessage
              openModal={createModal}
              close={() => {
                setCreateModal(false);
                getWorkerSchedule({
                  page: pagination?.page,
                  pageSize: pagination?.pageSize,
                });
              }}
              id={
                id
                  ? id
                  : isCustomer
                    ? sessionStorage.getItem('customerid')
                    : sessionStorage.getItem('workerId')
              }
              isCustomer={isCustomer}
            />
          )}
        </Col>
      </Row>
    </>
  );
}
